import { useMutation } from "react-query";
import { useAuthentication } from "../useAuthentication.ts";

export const useMutationDeleteSource = () => {
  const { accessToken } = useAuthentication();

  return useMutation(
    async ({ sourceId }: { sourceId: string }) => {
      const response = await fetch(
        `${import.meta.env.VITE_API_HOST}/sources/${sourceId}`,
        {
          method: "DELETE",
          headers: {
            authorization: accessToken ?? "",
          },
        },
      );

      if (!response.ok) {
        throw new Error("Failed to delete source");
      }
    },
    {
      onError: (error, data) => {
        console.error("Failed to delete source", error, data);
      },
    },
  );
};
